export default __webpack_public_path__ + "static/media/eth.410b364f.svg";